const PREFIX = 'SHFIT'

export const SET_SHIFT_SETTING = PREFIX + '.SET_SHIFT_SETTING'
